import { render } from "./DeceasedInfo.vue?vue&type=template&id=e748f400"
import script from "./DeceasedInfo.vue?vue&type=script&lang=js"
export * from "./DeceasedInfo.vue?vue&type=script&lang=js"

import "./DeceasedInfo.vue?vue&type=style&index=0&id=e748f400&lang=css"

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__